/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {memo} from "react";
import PropTypes from "prop-types";
import {Card} from "reactstrap";
import {FaTrash} from "react-icons/fa";
import CardActions from "./CardActions";

const CardList = ({
  listItems = [],
  listHeaders = [],
  cardContent: CardContent = () => {},
  withActions = false,
  actionsList = [],
  permsForActions = [],
  onSelectAction = () => {},
  rowClickable = false,
  onSelectRow = () => {},
  testId = "list-card",
  filterActionsOn,
}) => {
  const getActions = (cardData) => {
    if (filterActionsOn) {
      if (cardData[filterActionsOn]) {
        return actionsList;
      } else {
        return [{label: "Delete", icon: FaTrash}];
      }
    } else {
      return actionsList;
    }
  };

  const CardView = ({data, index}) => {
    return (
      <Card style={{margin: "0px 0px 10px 0px"}} className="card-list-item">
        {withActions && (
          <CardActions
            actionsList={getActions(data)}
            permsForActions={permsForActions}
            onSelectAction={(action) => onSelectAction(action, data)}
            cardData={data}
          />
        )}
        <div
          data-cy={testId}
          onClick={
            rowClickable
              ? () => {
                  onSelectRow(data);
                }
              : null
          }
          style={{cursor: rowClickable ? "pointer" : "default"}}
        >
          <CardContent data={data} headers={listHeaders} index={index} />
        </div>
      </Card>
    );
  };

  return (
    <div>
      {listItems?.map((item, index) => (
        <CardView key={index} data={item} index={index} />
      ))}
    </div>
  );
};

CardList.propTypes = {
  /** Data which is need to be displayed */
  listItems: PropTypes.array.isRequired,
  /** List of headers which will be passed to card content */
  listHeaders: PropTypes.array,
  /** Content of card which will rendered for each element in data */
  cardContent: PropTypes.func.isRequired,
  /** Wether to display action popover for each card */
  withActions: PropTypes.bool,
  /** List of actions which will be passed to action popover */
  actionsList: PropTypes.array,
  /** Permissions needed for actions */
  permsForActions: PropTypes.array,
  /** Function which will be executed when clicked on action */
  onSelectAction: PropTypes.func,
  /** Wether card is clickable */
  rowClickable: PropTypes.bool,
  /** Callback which will be executed on click of card */
  onSelectRow: PropTypes.func,
  /** Test id which will be passed to each card */
  testId: PropTypes.string,
};

export default memo(CardList);
